import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultsCounter = ({ totalResults, filteredResults, isLoading }) => {
  const percentage = totalResults > 0 ? Math.round((filteredResults / totalResults) * 100) : 0;

  return (
    <div className="bg-gradient-to-r from-primary/10 to-accent/10 border border-border rounded-xl p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-background rounded-xl shadow-md">
            {isLoading ? (
              <Icon name="Loader2" size={24} className="text-primary animate-spin" />
            ) : (
              <Icon name="Target" size={24} className="text-primary" />
            )}
          </div>
          <div>
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground mb-1">
              {isLoading ? 'Searching...' : 'Results Found'}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              {isLoading ? 'Applying your filters' : `${filteredResults} of ${totalResults} venues match`}
            </p>
          </div>
        </div>

        {!isLoading && (
          <div className="flex items-center gap-4">
            <div className="text-right">
              <div className="font-heading text-3xl md:text-4xl font-bold text-primary data-text">
                {filteredResults}
              </div>
              <p className="caption text-muted-foreground">venues</p>
            </div>
            <div className="hidden md:block w-px h-12 bg-border" />
            <div className="text-right">
              <div className="font-heading text-2xl md:text-3xl font-bold text-accent data-text">
                {percentage}%
              </div>
              <p className="caption text-muted-foreground">match rate</p>
            </div>
          </div>
        )}
      </div>

      {!isLoading && filteredResults === 0 && (
        <div className="mt-4 p-3 bg-warning/10 border border-warning/20 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="AlertTriangle" size={16} className="text-warning mt-0.5 flex-shrink-0" />
            <p className="text-xs md:text-sm text-warning">
              No venues match your current filters. Try adjusting your criteria or expanding the search radius.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResultsCounter;